import { useEffect, useState } from 'react';

export type DocumentPreviewImageProps = {
  file: File;
  alt?: string;
  scale?: number;
};
export function DocumentPreviewImage({
  file,
  alt,
  scale = 1,
}: DocumentPreviewImageProps) {
  const [imageSrc, setImageSrc] = useState<string | null>(null);

  useEffect(
    function () {
      const url = URL.createObjectURL(file);
      setImageSrc(url);

      // Cleanup memory when the component unmounts
      return () => URL.revokeObjectURL(url);
    },
    [file],
  );

  if (!imageSrc) return null; // Don't render if no image

  return (
    <div className="flex items-center justify-center">
      <img
        src={imageSrc}
        alt={alt}
        className="origin-top-left transition-transform duration-300"
        style={{ transform: `scale(${scale})` }}
      />
    </div>
  );
}
